import { CUSTOMER_CONSTRAINTS } from './constraints.js';
export function checkCustomerIdentity(values) {
    const name = values.name.trim();
    if (!name)
        return [{ path: 'name', message: 'Customer name is required.' }];
    return [];
}
// Mirrors createCustomerInputSchema's required fields for client-side validation.
export function checkCustomerCommercialRequired(values) {
    const issues = [];
    if (!values.paymentTermsId.trim()) {
        issues.push({
            path: 'paymentTermsId',
            message: `${CUSTOMER_CONSTRAINTS.paymentTerms.label} is required.`,
        });
    }
    if (!values.shipTermsId.trim()) {
        issues.push({
            path: 'shipTermsId',
            message: `${CUSTOMER_CONSTRAINTS.shipTerms.label} is required.`,
        });
    }
    return issues;
}
export function checkCustomerStatusRequired(values) {
    if (!values.statusId.trim()) {
        return [{ path: 'statusId', message: `${CUSTOMER_CONSTRAINTS.status.label} is required.` }];
    }
    return [];
}
//# sourceMappingURL=rules.js.map